import { __decorate } from "tslib";
import { ThemeContribution } from '@alipay/e2-editor-core';
import { singleton } from '@alipay/mana-syringe';
/**
 * 黑色主题配色
 */
export const DarkThemeConfig = {
    base: 'vs-dark',
    inherit: true,
    colors: {
        'editor.background': '#292C34',
        'editor.lineHighlightBackground': '#343F60',
        'editorCursor.foreground': '#ffffff',
        'editorIndentGuide.background': '#485065',
        'editor.selectionBackground': '#000',
        'editorBracketMatch.background': '#000',
        'editor.findMatchBackground': '#FFC600',
        'editorWarning.foreground': '#FFAD0A',
        'editorOverviewRuler.warningForeground': '#FFAD0A', // warning的右侧overview bar的颜色
    },
    rules: [
        { token: '', foreground: 'ffffff', background: 'BFBFBF' },
        { token: 'customKeywords', foreground: '2bc048' },
        { token: 'keywords', foreground: '46AAFF' },
        { token: 'number', foreground: 'FFFFFF' },
        { token: 'comment', foreground: '008000' },
        { token: 'builtinFunctions', foreground: '25b864' },
        { token: 'function', foreground: 'F14870' },
        { token: 'operator', foreground: '2BC048' },
        { token: 'string', foreground: 'FFC600' }, // 字符串颜色
    ],
};
let DarkTheme = class DarkTheme {
    registerItem(registry) {
        registry.registerMonacoTheme(DarkThemeConfig, 'dark');
    }
};
DarkTheme = __decorate([
    singleton({ contrib: ThemeContribution })
], DarkTheme);
export { DarkTheme };
